import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { NavHashLink } from "react-router-hash-link";
import styled from "styled-components";
import { BsArrowLeft } from "react-icons/bs";

const Styles = styled.div`
  width: ${({ width }) => width && width};
  ${({ isDisabled }) => isDisabled && "pointer-events: none;"};

  button {
    text-transform: ${({ isUppercase, textTransform }) =>
    isUppercase
      ? "uppercase"
      : textTransform
        ? textTransform
        : "none"} !important;
    width: ${({ width }) => width && width};
    background-color: ${(props) => (props.color ? props.color : "#161616")};
    color: ${(props) => (props.textColor ? props.textColor : "var(--white)")};
    padding-top: ${(props) => (props.paddingTop ? props.paddingTop : "1.5rem")};
    padding-bottom: ${(props) =>
    props.paddingBottom ? props.paddingBottom : "1.5rem"};
    padding-left: ${(props) =>
    props.paddingLeft ? props.paddingLeft : "1rem"};
    padding-right: ${(props) =>
    props.paddingRight ? props.paddingRight : "1rem"};
    font-weight: ${({ fontWieght }) => (fontWieght ? fontWieght : "bold")};
    height: ${({ height }) => (height ? height : "38px")};
    border: ${({ border, color, isDisabled }) =>
    border
      ? border
      : color
        ? `1px solid ${color}`
        : isDisabled
          ? "none"
          : "1px solid #161616"} !important;
    border-color: ${({ borderColor }) => borderColor}!important;
    border-radius: ${(props) =>
    props.borderRadius ? props.borderRadius : "var(--border-radius) !important"};
    display: flex;
    justify-content: center;
    align-items: center;
    /* flex-direction: ${({ isAr }) => (isAr ? "row" : "row-reverse")}; */
  }
  button:active,
  button:hover {
    background-color: ${(props) =>
    props.color ? props.color : "#161616ad"} !important;
    color: ${(props) =>
    props.textColor ? props.textColor : "white"}!important;
    transition: all 0.3s cubic-bezier(0.4, 0, 1, 1) 0s;
    filter: brightness(0.9);
  }
  button:disabled {
    background-color: #cccccc !important;
    color: #818183 !important;
  }
  a {
    width: 100%;
    text-decoration: none !important;
  }
  a:hover {
    text-decoration: none !important;
    /* filter: brightness(0.9); */
    filter: brightness(1);
  }
  .icon {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-inline-start: 10px;
    ${({ isAr, rotateIcon }) => !isAr && rotateIcon && "transform: rotate(180deg)"};
    svg {
      color: ${({ iconColor }) => iconColor ? iconColor : "var(--main-color)"};
    }
    /* &::before {
      position: absolute;
      content: "";
      background-color: var(--main-color);
      width: 14px;
      height: 0.6px;
      top: 50%;
      left: 80%;
      transform: translate(-50%, -50%);
    } */
  }
  /* ---- MOBILE ---- */
`;
const CustomBtn = ({
  onClick,
  isHashLink = false,
  link = false,
  external,
  text,
  fontWieght,
  color,
  border,
  borderColor,
  borderRadius,
  textColor,
  isDisabled,
  type,
  paddingTop,
  paddingBottom,
  paddingLeft,
  paddingRight,
  id,
  width,
  className,
  withoutTranslate,
  isUppercase,
  textTransform = "capitalize",
  height,
  withIcon,
  iconColor,
  icon,
  rotateIcon = true,
}) => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language === "ar";
  return (
    <Styles
      color={color}
      textColor={textColor}
      border={border}
      borderColor={borderColor}
      width={width}
      paddingTop={paddingTop}
      isDisabled={isDisabled}
      paddingBottom={paddingBottom}
      borderRadius={borderRadius}
      paddingRight={paddingRight}
      paddingLeft={paddingLeft}
      className={className}
      isUppercase={isUppercase}
      height={height}
      textTransform={textTransform}
      fontWieght={fontWieght}
      isAr={isAr}
      iconColor={iconColor}
      rotateIcon={rotateIcon}
    >
      {link ? (
        external ? (
          <a href={link} target={external && "_blank"}>
            <Button
              disabled={isDisabled}
              className="rounded-0"
              id={id}
              onClick={onClick}
            >
              {withoutTranslate ? text : t(text)}
              {withIcon && (
                <div className="icon">
                  {icon ? icon : <BsArrowLeft size={24} />}
                </div>
              )}
            </Button>
          </a>
        ) : isHashLink ? (
          <NavHashLink to={link} smooth>
            <Button
              disabled={isDisabled}
              className="rounded-0"
              id={id}
              onClick={onClick}
            >
              {withoutTranslate ? text : t(text)}
              {withIcon && (
                <div className="icon">
                  {icon ? icon : <BsArrowLeft size={24} />}
                </div>
              )}
            </Button>
          </NavHashLink>
        ) : (
          <Link to={link}>
            <Button
              disabled={isDisabled}
              className="rounded-0"
              id={id}
              onClick={onClick}
            >
              {withoutTranslate ? text : t(text)}
              {withIcon && (
                <div className="icon">
                  {icon ? icon : <BsArrowLeft size={24} />}
                </div>
              )}
            </Button>
          </Link>
        )
      ) : (
        <>
          <Button
            className="rounded-0"
            id={id}
            onClick={onClick}
            disabled={isDisabled}
            type={type}
          >
            {withoutTranslate ? text : t(text)}
            {withIcon && (
              <div className="icon">
                {icon ? icon : <BsArrowLeft size={24} />}
              </div>
            )}
          </Button>
        </>
      )}
    </Styles>
  );
};

export default CustomBtn;
